import { WebSocketClient } from '@/utils/websocket'

export default {
  namespaced: true,

  state: {
    connected: false,
    reconnecting: false,
    taskProgress: {}
  },

  mutations: {
    SET_CONNECTED(state, status) {
      state.connected = status
    },
    SET_RECONNECTING(state, status) {
      state.reconnecting = status
    }
  },

  actions: {
    connect({ commit, dispatch, rootState }) {
      const token = rootState.auth.token
      if (!token) return

      const wsUrl = `${process.env.VUE_APP_WS_URL}?token=${token}`
      
      // 使用单例模式获取 WebSocket 实例
      WebSocketClient.getInstance(wsUrl, {
        onOpen: () => {
          commit('SET_CONNECTED', true)
          commit('SET_RECONNECTING', false)
        },
        onClose: () => {
          commit('SET_CONNECTED', false)
        },
        onReconnecting: () => {
          commit('SET_RECONNECTING', true)
        },
        onMessage: (event) => {
          try {
            const data = JSON.parse(event.data)
            dispatch('handleMessage', data)
          } catch (error) {
            console.error('Failed to parse WebSocket message:', error)
          }
        }
      })
    },

    async handleMessage({ commit, dispatch }, data) {
      // 显示消息通知
      const app = document.getElementById('app').__vue__
      try {
        await dispatch('auth/fetchUserProfile', null, { root: true })
      } catch (error) {
        console.error('Failed to update user profile:', error)
      }
      switch (data.type) {
        case 'task_status':
          if (app) {
            app.showMessage({
              title: data.taskType+' 编号：'+data.id,
              status: data.status,
              message: data.message,
              route: `/workspace/tasks?id=${data.id}`
            })
          }
          break
        case 'order_paid':
          if (app) {
            app.showMessage({
              title: '订单支付成功' + data.id,
              status: data.status,
              message: data.message,
              route: `/workspace/tasks`
            })
          }
          break
        case 'voice_role_status':
          if (app) {
            app.showMessage({
              title: '声音角色：'+data.name,
              status: data.status,
              message: data.message,
              route: `/workspace/sound-cloning`
            })
          }
          break
      }
    },

    disconnect({ commit }) {
      // 销毁 WebSocket 单例
      WebSocketClient.destroy()
      commit('SET_CONNECTED', false)
      commit('SET_RECONNECTING', false)
    }
  },

  getters: {
    getTaskProgress: (state) => (taskId) => {
      return state.taskProgress[taskId] || 0
    }
  }
} 